import types from './action-types'

export const fetchCommissionsSales = ({ options }: { options: Record<string, any> }) => {
  return {
    type: types.ENTITIES_FETCH_BEGIN,
    options,
  }
}
export type FetchShiftBookingsAction = ReturnType<typeof fetchCommissionsSales>
